import {useSelector, useDispatch} from 'react-redux';
import {Navbar, Nav, Container, Button} from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import API from '../helpers/api';
import {useState, useEffect} from 'react';
import { useMemo } from 'react';

export default function NavigationBar() {
    const user = useSelector (state => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const api = useMemo(() => new API({dispatch}), [dispatch]);
    const [subMenuOpen, setSubmenuOpen] = useState(false);

    

    const logout = () => {
        api.clearAuthToken();
        navigate('/');
    }
    console.log(user);

    if (!user.user) return null;

    return (
        <Navbar bg="dark" variant="dark" expand="xs">
            <Container>
                <Navbar.Brand href="/">TCC Support Tool</Navbar.Brand>
                
                
                <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setSubmenuOpen(!subMenuOpen)} >
                    Menu
                </Navbar.Toggle>

                <Navbar.Collapse id="basic-navbar-nav" className={subMenuOpen ? 'show' : ''}>
                    <Nav className="me-auto">
                        <Nav.Link href="/customers">Customers</Nav.Link>
                        {user.user.is_admin && <Nav.Link href="/admin">Admin</Nav.Link>}
                    </Nav>
                    <hr/>
                    <Nav className="ml-auto">
                        <Navbar.Text className="me-3">
                            Welcome, {user.user.first_name}
                        </Navbar.Text>
                        <Button variant="outline-light" onClick={logout}>Logout</Button>
                    </Nav>

                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}